<template>
	<i v-if="!refresh">
		<i :data-feather="dataFeather"></i>
	</i>
</template>

<script>
	export default {
		name: 'Icon',
		data() {
			return {
				refresh: false
			}
		},
		props: {
			dataFeather: String
		},
		created() {
			this.$nextTick(() => {
				feather.replace({
					'stroke-width': 1.5
				});
			})
		},
		watch: {
			dataFeather(val) {
				this.refresh = true
			},
			refresh() {
				this.$nextTick(() => {
					this.refresh = false
					this.$nextTick(() => {
						feather.replace({
							'stroke-width': 1.5
						});
					})
				})
			}
		}
	}
</script>

<style scoped>

</style>
